import { ActionBar } from '@dreryk/react-components';

import { DosageTemplates } from '~legacy.visit';
import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

export const DosageTemplatesTabContent = (): JSX.Element => {
   return (
      <ActionBar testId={'dosageTemplates'} id={'dosageTemplates'}>
         <DosageTemplates
            editSlot={({ handleSubmit, ready, saveBlocked, onTemplateSaveSuccess }) => (
               <>
                  <DosageTemplates.SendTemplateButton
                     handleSubmit={handleSubmit}
                     onSuccess={onTemplateSaveSuccess}
                     disabled={ready || saveBlocked}
                  />
                  <FormsTemplates.CancelActionBarPrimaryLink />
               </>
            )}
         />
      </ActionBar>
   );
};
